<template>
  <div slot="pop-body">
    <div class="my-pop-alert">
      <div class="my-pop-alert-top"><span>시청 예약</span></div>
      <alarm-list-live></alarm-list-live>
    </div>
  </div>
</template>
<script>
import AlarmListLive from '@/components/mypooq/AlarmListLive'
export default {
  name: 'AlarmPopupBodyLive',
  components: { AlarmListLive },
  data () {
    return {

    }
  }
}
</script>
